export enum NodeType {
    normal,
    treatment,
    head,
    neighborhood_entry,
    neighborhood_head
}

export const allNodeTypes: Array<NodeType> = [
  NodeType.normal,
  NodeType.treatment,
  NodeType.head,
  NodeType.neighborhood_entry,
  NodeType.neighborhood_head ];

export enum OverflowDirection {
  None = 0,
  Top,
  Bottom
}
